/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnconversation2Inputs */

const en_moderationcolumnconversation2 = /** @type {(inputs: Moderationcolumnconversation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

const de_moderationcolumnconversation2 = /** @type {(inputs: Moderationcolumnconversation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat`)
};

/**
* | output |
* | --- |
* | "Chat" |
*
* @param {Moderationcolumnconversation2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnconversation2 = /** @type {((inputs?: Moderationcolumnconversation2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnconversation2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnconversation2(inputs)
	return de_moderationcolumnconversation2(inputs)
});
export { moderationcolumnconversation2 as "moderationColumnConversation" }